"use strict";
import { useState } from "react";

import { CallCenterUserCredentialsState, ProviderTypes } from "./CallCenterSettings.types";
import { EditCallCenterComUnikCredentials } from "./EditCallCenterComUnikCredentials";
import { ViewCallCenterCredentials } from "./ViewCallCenterCredentials";

interface CallCenterCredentialsProps {
    credentials: CallCenterUserCredentialsState,
    saveCredentials: (credentials: CallCenterUserCredentialsState) => Promise<void>
}

function CallCenterCredentials(props: Readonly<CallCenterCredentialsProps>): JSX.Element {
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);

    async function onSave(credentialsToSave: CallCenterUserCredentialsState): Promise<void> {
        setSaving(true);
        let success = false;
        try {
            await props.saveCredentials(credentialsToSave);
            success = true;
        }
        catch (ex) {
            success = false;
        }
        setSaving(false);
        if (success) {
            setEditing(false);
        }
    }

    function onModify(): void {
        setEditing(true);
    }

    function onCancel(): void {
        setEditing(false);
    }

    if (editing) {
        switch (props.credentials?.Provider ?? null) {
            case null: // set as default type
            case ProviderTypes.ComUnik:
                return (
                    <EditCallCenterComUnikCredentials
                        credentials={props.credentials}
                        disabled={saving}
                        onCancel={onCancel}
                        onSave={onSave}
                    />
                );
            default:
                console.error("Invalid CallCenter Provider Type for credentials.", props.credentials);
                return <div>{cacheStore.GetString("CallCenter_UnsupportedCredentialType")}</div>;
        }
    }
    else {
        return (
            <ViewCallCenterCredentials
                credentials={props.credentials}
                onModifyClicked={onModify}
            />
        );
    }
}

export { CallCenterCredentials };
